// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"2d149468","213":"69e24274","239":"122cf73d","278":"3e35a54e","626":"521c31a7","667":"fedf31c3"}[chunkId] + ".chunk.js";
};